var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIconNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5665 5.83333C17.4225 5.58385 17.2163 5.37594 16.968 5.22989C16.7198 5.08384 16.4379 5.00464 16.1498 5H5.48317L4.99984 3.11667C4.951 2.93487 4.84205 2.77495 4.69073 2.66298C4.53941 2.551 4.35464 2.49356 4.1665 2.5H2.49984C2.27882 2.5 2.06686 2.5878 1.91058 2.74408C1.7543 2.90036 1.6665 3.11232 1.6665 3.33333C1.6665 3.55435 1.7543 3.76631 1.91058 3.92259C2.06686 4.07887 2.27882 4.16667 2.49984 4.16667H3.53317L5.83317 12.7167C5.882 12.8985 5.99095 13.0584 6.14227 13.1704C6.29359 13.2823 6.47837 13.3398 6.6665 13.3333H14.1665C14.3204 13.3329 14.4711 13.2898 14.6021 13.2089C14.733 13.128 14.8389 13.0124 14.9082 12.875L17.6415 7.40833C17.76 7.16001 17.8151 6.88623 17.802 6.6114C17.789 6.33658 17.708 6.06927 17.5665 5.83333ZM13.6498 11.6667H7.29984L5.9415 6.66667H16.1498L13.6498 11.6667Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17.5C6.94036 17.5 7.5 16.9404 7.5 16.25C7.5 15.5596 6.94036 15 6.25 15C5.55964 15 5 15.5596 5 16.25C5 16.9404 5.55964 17.5 6.25 17.5Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 17.5C15.2739 17.5 15.8335 16.9404 15.8335 16.25C15.8335 15.5596 15.2739 15 14.5835 15C13.8931 15 13.3335 15.5596 13.3335 16.25C13.3335 16.9404 13.8931 17.5 14.5835 17.5Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconNav);
export default __webpack_public_path__ + "static/media/cart_icon-nav.d3ba1980cac0ad02347738c34e58a9e2.svg";
export { ForwardRef as ReactComponent };